export const ColumnDefsMobile = [
    {
        headerName: "FROM",
        field: "latestUserName"                 
    },
    {headerName: "SUBJECT", field: "subject"}
];
